import { generateClassName, getColorVariantFromBackground } from '@klv/shared/utils/functions';
import Buttons from '@klv/molecules/buttons';
import Icon from '@klv/atoms/icon';

import * as s from './styles/bulletedList.module.scss';

import type { IButtonProps } from '@klv/atoms/button/types';
import type { TColorVariant } from '@klv/shared/styles/types';

interface IListBullet {
  text: string;
}
export interface IBulletedList {
  background: TColorVariant;
  bullets?: IListBullet[];
  buttons?: IButtonProps[];
  headline?: string;
}

const BulletedList = ({
  background,
  bullets,
  buttons,
  headline = '',
  ...props
}: IBulletedList) => (
  <div
    className={
      generateClassName([
        s.bulletedList,
        s[background],
        "defaultPaddingTop",
        "defaultPaddingBottom",
      ])
    }
    {...props}
  >
    <div className="grid">
      {headline && <h2 className={generateClassName([s.headline, s[background], "h4"])}>{headline}</h2> }
      {bullets && bullets?.length > 0 && (
      <ul className={s.bullets}>
        {bullets.map((bullet) => (
          <li className={s.bullet} key={bullet.text}>
            <Icon
              className={s.bulletIcon}
              fillColor="currentColor"
              iconName="CheckBullet"
              size={2.4}
              aria-hidden="true"
            />
            <span
              className={
                generateClassName([
                  s.bulletText,
                  "tagline",
                ])}
              >
                {bullet.text}
              </span>
          </li>
        ))}
      </ul>
      )}
      {buttons && buttons?.length > 0 && (
        <Buttons
          className={s.buttons}
          buttons={buttons}
          buttonColor={getColorVariantFromBackground(background)}
          variants={['tertiary']}
        />
      )}
    </div>
  </div>
)

export default BulletedList;
